<template>
  <div class="items" v-if="swaggerObject">
    <div class="items__info">
      {{ $t("pages.datasetList.filterInfo.visible") }}
      <strong>{{
        $tc("pages.datasetList.filterInfo.datasets", items.length)
      }}</strong>
      {{ $t("pages.datasetList.filterInfo.of") }}
      {{ Object.keys(swaggerObject.datasets).length / 2 }}
    </div>

    <div v-for="item in items" :key="item.key" class="item">
      <h3 class="item__heading">{{ swaggerObject.getSummary(item.key) }}</h3>
      <p class="item__desc">{{ swaggerObject.getDescription(item.key) }}</p>

      <div class="item__footer">
        <div class="item__footer-tags">
          <el-tag
            v-for="tag in swaggerObject.getTags(item.key)"
            :key="`tags-${tag}`"
            class="item__footer-tag"
          >
            {{ tag }}
          </el-tag>
        </div>
        <div class="item__footer-btn">
          <el-button
            type="primary"
            :routerLink="localizedLink(datasetDetailLink(item))"
            >{{ $t("show-dataset-detail") }}</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { localizedLink } from "@/mixins";

export default {
  props: ["items", "swaggerObject"],
  mixins: [localizedLink],
  methods: {
    datasetDetailLink(item) {
      return { name: "datasets", hash: `dataset=${item.key}` };
    }
  }
};
</script>

<style lang="scss" scoped>
.items {
  margin-bottom: rem(30);
  @include media("<navbar-sm") {
    margin-top: rem(30);
  }
}

.items__info {
  margin-bottom: em(30, 18);
  font-size: rem(18);
  color: $--color-text-dark;
  @include media("<navbar-sm") {
    font-size: rem(16);
  }
}

.item {
  margin: 0 0 20px;
  padding: rem(28) rem(30) rem(30);
  border: 1px solid $--color-gray-0;
  box-shadow: 0px 4px 15px rgba(161, 161, 161, 0.1);
  border-radius: 4px;
  @include media("<navbar-sm") {
    padding: rem(22) rem(16) rem(24);
  }
}

.item__heading {
  margin: 0 0 em(15, 20);
  font-weight: 700;
  font-size: rem(20);
  line-height: 1.38;
  text-align: left;
  color: $--text-primary;
  @include media("<navbar-sm") {
    margin-bottom: em(30, 18);
    font-size: rem(18);
  }
}

.item__desc {
  margin-bottom: rem(20);
  @include media("<navbar-sm") {
    display: none;
  }
}

.item__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  // @include media("<navbar-sm") {
  //   flex-wrap: wrap;
  // }
}

.item__footer-tags {
  margin: 0 20px 0 0;
  @include media("<navbar-sm") {
    display: flex;
  }
}

.item__footer-tag {
  @include media("<navbar-sm") {
    white-space: normal;
    flex-basis: 0;
  }
}
</style>
